import { render, staticRenderFns } from "./QuillMessageField.vue?vue&type=template&id=18516911"
import script from "./QuillMessageField.vue?vue&type=script&lang=js"
export * from "./QuillMessageField.vue?vue&type=script&lang=js"
import style0 from "./QuillMessageField.vue?vue&type=style&index=0&id=18516911&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports